module.exports = __webpack_public_path__ + "static/media/schedule_demo.67fec79d.png";